import React, { useState, useEffect } from "react";
import { ReviewArticle } from "./ReviewArticle";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { ReviewData } from "./ReviewData";
import "./Review.css";

export const ReviewMain = () => {
  const [peoples] = useState(ReviewData);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const lastIndex = peoples.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, peoples]);

  useEffect(() => {
    const AutoSlideSetting = setInterval(() => {
      setIndex((previous) => previous + 1);
    }, 10000);
    return () => clearInterval(AutoSlideSetting);
  }, []);

  return (
    <div className="Slide-app">
      <header className="App-header">
        <p data-aos="zoom-out-left">
          <span className="span-review">/</span> People I've worked with have
          said some nice things...
        </p>
      </header>
      <section
        data-aos="fade-down"
        data-aos-easing="linear"
        className="section-center-slide"
      >
        <ReviewArticle peoples={peoples} index={index} />

        <button
          onClick={() => setIndex(index - 1)}
          className="btn1Slide flex-btn-Slide"
        >
          <FaAngleLeft />
        </button>
        <button
          onClick={() => setIndex(index + 1)}
          className="btn2Slide flex-btn-Slide"
        >
          <FaAngleRight />
        </button>
        {/* This button for slide indicator */}
        <section className="btn-slide-indicator-container">
          {peoples.map((people, peopleIndex) => {
            return (
              <button
                onClick={() => {
                  setIndex(peopleIndex);
                }}
                key={people.id}
                className={
                  peopleIndex === index ? "circle-btn active" : "circle-btn"
                }
              ></button>
            );
          })}
        </section>
      </section>
    </div>
  );
};
